import Vue from 'vue';
import VueRouter from 'vue-router';
import Module from './views/Module.vue';
import Home from './views/Home.vue';
import Imprint from './views/Imprint.vue';
import Personas from './views/Personas.vue';
import LinkList from './views/LinkList.vue';
import store from './store';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home
    },
    {
        path: '/impressum',
        name: 'imprint',
        component: Imprint
    },
    {
        path: '/personas',
        name: 'personas',
        component: Personas
    },
    {
        path: '/sammelkiste/:module?',
        name: 'linkList',
        props: route => ({
            module: route.params.module || '0'
        }),
        component: LinkList
    },
    {
        path: '/anleitung/:slide?',
        name: 'tutorial',
        props: route => ({
            module: '0',
            slide: parseInt(route.params.slide || 1, 10)
        }),
        component: Module
    },
    {
        path: '/lerneinheit/:module/:slide?',
        name: 'module',
        props: route => ({
            module: route.params.module,
            slide: parseInt(route.params.slide || 1, 10)
        }),
        component: Module
    }
];

const router = new VueRouter({routes});

router.beforeEach((to, from, next) =>
{
    if (process.env.NODE_ENV === 'development' || store.state.tutorialOffered === true)
    {
        next();
        return;
    }
    store.commit('offerTutorial');
    next({name: 'tutorial'});
});

export default router;
